module.exports = __webpack_public_path__ + "static/media/G1-28-Katherine-Adamopoulos-cod59.c8c94b6c.png";